module.exports = __webpack_public_path__ + "static/media/glass.75dec372.svg";